exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-c7641b60]{padding:40px}@media screen and (min-width:425px){form[data-v-c7641b60]{padding:calc(23.25123px + 3.94089vw)}}@media screen and (min-width:1440px){form[data-v-c7641b60]{padding:80px}}.title[data-v-c7641b60]{margin:0;color:var(--dark-tan);text-transform:uppercase;font-weight:700;font-size:18px}.secondary-action[data-v-c7641b60]{text-decoration:underline!important;font-size:12px;cursor:pointer}.register-img[data-v-c7641b60]{position:relative}.register-img img[data-v-c7641b60]{position:absolute;top:0;left:0;height:100%;width:100%;object-fit:cover}", ""]);

// exports
